export default {
    category: {
        cta: "查看产品"
    }
}